import { useState } from "react";

import { SearchIcon, CountryIcon } from "../../assets/Icons";
import { Button } from "../../components/Reusable/Button";
import { LabelInput } from "../../components/Reusable/Layout";
import { ModalContainer } from "../../components/PageComponents";
import { CloseIcon } from "../../icons/promotions";

export const SettingsTable = ({
  onUserClick,
  settingsData,
}: {
  onUserClick: (user: any) => void;
  settingsData: any[];
}) => {
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Calculate pagination values
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = settingsData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(settingsData.length / itemsPerPage);

  // Handle page navigation
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <table className="w-full border border-[#FFFFFF1A] rounded-2xl overflow-hidden font-satoshi">
          <thead>
            <tr className="bg-gray-100 dark:bg-[#FFFFFF1A] text-gray-600 dark:text-white uppercase text-xs bp:text-sm leading-normal h-[50px]">
              <th className="px-6 text-left ">Settings</th>
              <th className="px-6 text-left ">Default Value</th>
              <th className="px-6 text-left ">Type</th>
              <th className="px-6 text-left">Visible to User</th>
              <th className="px-6 text-left"></th>
            </tr>
          </thead>
          <tbody className="text-gray-600 dark:text-white text-xs bp:text-sm">
            {currentItems.length > 0 ? (
              currentItems.map((data) => (
                <tr
                  key={data.id}
                  className="border-b border-gray-200 h-[50px]"
                  onClick={() => onUserClick(data)}
                >
                  <td className="px-6 ">{data.setting}</td>
                  <td className="px-6 ">{data.defaultValue}</td>
                  <td className="px-6 ">{data.type}</td>
                  <td className="px-6">{data.visibleToUser}</td>
                  <td className="px-6 text-blue-400">{data.action}</td>
                </tr>
              ))
            ) : (
              <tr className="border-b border-gray-200 h-[50px]">
                <td colSpan={5} className="px-6 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center border-t border-[#FFFFFF1A]">
        <button
          className={`border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A] ${
            currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={goToPreviousPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className="text-gray-600 dark:text-white text-xs bp:text-sm">
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          className={`border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-4 py-2 rounded-md text-xs bp:text-sm dark:text-white dark:bg-[#FFFFFF1A] ${
            currentPage === totalPages || totalPages === 0
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
          onClick={goToNextPage}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export const SettingsSearchFilter = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="flex flex-col bp:flex-row bp:items-center bp:justify-between mb-4 gap-2">
      <div className="relative">
        <input
          type="text"
          placeholder="Search for a user..."
          className="border p-2 pl-10 rounded-3xl w-[260px] h-[40px] bp:h-[48px] bp:w-[645px] dark:text-white dark:bg-[#FFFFFF1A] bg-[#F4F4F5] dark:border-[#FFFFFF1A]"
        />
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
          <SearchIcon />
        </div>
      </div>
      <div>
        <Button
          onClick={onClick}
          bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
          textColor="text-white"
          borderRadius="rounded-lg"
          className="w-[274px] h-[48px] ml-6"
        >
          <div className="flex items-center gap-2">
            <span className="ml-2 text-lgh">+</span>
            <p>ADD MERCHANT SETTINGS</p>
          </div>
        </Button>
      </div>
    </div>
  );
};

export const AddMarchantModal = ({
  onClose,
  isOpen,
  handleOverlayClick,
  handleModalClick,
}: {
  onClose: () => void;
  isOpen: boolean;
  handleOverlayClick: (e: React.MouseEvent) => void;
  handleModalClick: (e: React.MouseEvent) => void;
}) => {
  if (!isOpen) return null;
  return (
    <ModalContainer
      title="Add Merchant Settings"
      closeIcon={
        <button onClick={onClose}>
          <CloseIcon />
        </button>
      }
    >
      <div className="space-y-4 mt-2">
        <div>
          <LabelInput
            type="text"
            value="Settings"
            placeholder="Enter Setting"
            name="settings"
          />
        </div>
        <div>
          <LabelInput
            type="text"
            value="Defaut Value"
            placeholder="Enter Setting"
            name="defualtValue"
          />
        </div>
        <div>
          <LabelInput
            type="text"
            value="Type"
            placeholder="Dropdown"
            name="type"
          />
        </div>
        <div>
          <LabelInput
            type="text"
            value="Visible to User"
            placeholder="Visible"
            name="visibility"
          />
        </div>
        <div className="flex justify-end">
          <Button
            bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
            textColor="text-white"
            borderRadius="rounded-lg"
            className="w-[250px] h-[48px] ml-6"
          >
            ADD MERCHANT SETTINGS
          </Button>
        </div>
      </div>
    </ModalContainer>
  );
};
